var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#163567"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0303 4.88389C11.7374 4.59099 11.2626 4.59099 10.9697 4.88389L10.3536 5.5L12 7.14645L12.6161 6.53033C12.909 6.23744 12.909 5.76256 12.6161 5.46967L12.0303 4.88389ZM12.9697 6.88388C13.4578 6.39573 13.4578 5.60427 12.9697 5.11612L12.3839 4.53033C11.8957 4.04218 11.1043 4.04218 10.6161 4.53033L9.82344 5.32301C9.82337 5.32308 9.8233 5.32315 9.82322 5.32322C9.82315 5.3233 9.82308 5.32337 9.823 5.32344L4.82322 10.3232C4.77634 10.3701 4.75 10.4337 4.75 10.5V12.5C4.75 12.6381 4.86193 12.75 5 12.75H7C7.0663 12.75 7.12989 12.7237 7.17678 12.6768L12.9697 6.88388ZM11.6464 7.5L10 5.85356L5.25 10.6036V12.25H6.89645L11.6464 7.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.e1483697a0cc07bc667779fba3f376e0.svg";
export { ForwardRef as ReactComponent };